<template>
    <v-dialog v-model="abrirDialog" max-width="580px" class="pa-5" persistent>
        <v-card>
            <v-btn icon class="close-btn" @click="abrirDialog = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-card-title class="text-h5 font-weight-bold text-h5" color="primary">Limite de crédito excedido</v-card-title>
            <br>
            <v-card-text>
                <p class="text-body-1 texto">
                    A proposta <b>ultrapassou o limite de crédito configurado para seu ponto de venda. </b>Entre em contato com seu <b>Gerente de Negócio</b> para ajustar seu limite de crédito.
                </p>
                <p class="text-body-1 texto">
                    <b>OBS:</b> Sua <b>proposta será finalizada</b> apenas <b>após o ajuste do limite de crédito</b> do ponto de venda.
                </p>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn id="btn-fechar-dialog" color="primary" @click="prosseguir">Prosseguir</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    props: {
      visivel: {
        type: Boolean,
        required: true
      },
      limiteAtual: {
        type: String,
        required: true
      },
      limiteParaAumentar: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        abrirDialog: this.visivel
      }
    },
    watch: {
      visivel (newValue) {
        this.abrirDialog = newValue
      },
      abrirDialog (newValue) {
        if (newValue === false) {
          this.$emit('fecharInformativoLimiteCreditoPontoVendaExcedido', newValue)
        }
      }
    },
    methods: {
      fecharDialog () {
        this.abrirDialog = false
      },
      prosseguir () {
        this.abrirDialog = false
        this.$emit('prosseguirInformativoLimiteCreditoPontoVendaExcedido')
      }
    }
  }
</script>

<style scoped>
.texto {
  font-size: 1.2rem;
  line-height: 1.6;
}
.texto-limite-atual {
  font-size: 1.2rem;
  font-weight: bold;
}
.texto-valor-lmite-atual {
  font-size: 1.4rem;
  font-weight: bold;
}
.texto-limite-credito {
  font-size: 1.2rem;
  font-weight: bold;
}
.texto-valor-limite-credito {
  font-size: 1.4rem;
  font-weight: bold;
}
.v-dialog {
  padding: 24px;
}
.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
}
.v-icon.mx-6 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}
</style>
